module.exports = __webpack_public_path__ + "img/Rookie-3.31b96f27.gif";